const FlyoutContentList = ({ items = [], onSelect }) => {
  return (
    <ul className="spo-m-flyout-content-list m-selectable-list m-selectable-list--no-border">
      {items.map((i) => (
        <li key={i.value} onClick={() => onSelect(i)}>
          <span className="m-selectable-list__item">{i.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default FlyoutContentList;
